<template>
  <div class="nav-bar">
    <h1 class="title">
      <RouterLink to="/">
        <img :src="require('@/assets/images/logo.svg')" alt="funtowait logo" width="88" />
      </RouterLink>
    </h1>
    <span v-if="isRightColShown" class="right-col">
      <NavPoints :key="navKey" :nav-key="navKey" />
      <VButton
        class="menu-button"
        type="button"
        ui-type="transparent"
        icon-name="menu"
        :icon-size="24"
        @click="$emit('menu-clicked', true)"
      />
    </span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import VButton from "@/components/atoms/v-button.vue";
import NavPoints from "@/components/atoms/points/nav-points.vue";

export default defineComponent({
  name: "component-nav-points",
  components: { VButton, NavPoints },
  props: {
    isRightColShown: {
      type: Boolean,
      default: true
    },
    navKey: {
      type: Number,
      default: 0
    }
  }
});
</script>

<style lang="scss" scoped>
.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  height: calc(#{$nav-height} - 40px);
  padding: 20px;

  .title {
    font-size: 15.647px;
    font-weight: 700;
    a {
      text-decoration: none;
      color: $fun-text;

      &:visited {
        color: $fun-text;
      }
    }
  }

  .right-col {
    display: flex;
    align-items: center;

    .nav-points {
      margin-right: 20px;
    }

    .menu-button {
      width: 24px;
      height: 24px;
      min-height: 24px;
      padding: 0;
    }
  }
}
</style>
